import * as angular from 'angular';

"use strict";

angular.module('SuperUserModule', [])

export default 'SuperUserModule';